"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var _ = __importStar(require("lodash"));
var Select_1 = __importDefault(require("components/common/inputs/Select"));
var AddButton_1 = __importDefault(require("../buttons/AddButton"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var SelectWithNewEntry = function (_a) {
    var value = _a.value, label = _a.label, data = _a.data, onChange = _a.onChange, onSubmit = _a.onSubmit, busy = _a.busy;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = react_1.useState(''), newEntry = _c[0], setNewEntry = _c[1];
    var inputRef = react_1.useRef(null);
    react_1.useEffect(function () {
        document.addEventListener('keyup', keyHandler);
        return function () {
            document.removeEventListener('keyup', keyHandler);
        };
    });
    var keyHandler = function (e) {
        if (e.key === 'Escape' && open) {
            setOpen(false);
        }
    };
    var toggleOpen = function () {
        setOpen(!open);
    };
    var changeHandler = function (e) {
        setNewEntry(e.currentTarget.value);
    };
    var submitHandler = function (e) {
        e.preventDefault();
        if (newEntry.length <= 0) {
            // TODO notify
            return;
        }
        setNewEntry('');
        setOpen(false);
        onSubmit(_.startCase(newEntry));
    };
    return (react_1.default.createElement("div", { className: 'select-with-new-entry' },
        react_1.default.createElement("div", { className: 'select-with-new-entry__section flex flex-row' },
            react_1.default.createElement("span", { className: 'select-with-new-entry__label' },
                label,
                ":"),
            react_1.default.createElement(Select_1.default, { value: value, options: data.map(function (item) { return ({
                    value: item,
                    text: item.name || item,
                    disabled: item.hasOwnProperty('live') && !item.live || false
                }); }), busy: busy, onChange: onChange })),
        react_1.default.createElement("div", { className: 'select-with-new-entry__add' },
            !open &&
                react_1.default.createElement(AddButton_1.default, { label: "Add new " + label.toLowerCase() + " ", onClick: toggleOpen }),
            open &&
                react_1.default.createElement("form", { className: 'select-with-new-entry__form', onSubmit: submitHandler },
                    react_1.default.createElement("button", { type: 'button', className: 'select-with-new-entry__form__close flex flex-column flex-center', "aria-label": 'Close', title: 'Close', onClick: toggleOpen },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close' })),
                    react_1.default.createElement("input", { ref: inputRef, autoFocus: true, type: 'text', name: 'categoryName', placeholder: "Fill in name and press enter", value: newEntry, onChange: changeHandler })))));
};
exports.default = SelectWithNewEntry;
